module.exports = __webpack_public_path__ + "img/Asset 1.d498829c.png";